import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const ArrowDownFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function ArrowDownFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path d="M13.5 15.705V3.585h-3v12.12L3 10.455v3.66l9 6.3 9-6.3v-3.66l-7.5 5.25Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default ArrowDownFilled;